import { colors } from '@insurancemenu/imenu-components-lib';
import { breakpointsMQ4 } from '@insurancemenu/imenu-components-lib/dist/utils/breakpoints';
import { createUseStyles } from 'react-jss';
import styled, { css, CSSProp } from 'styled-components';

export const ElectionsStickyBarStyled = styled.div`
  position: sticky;
  top: 0;
  z-index: 1;
  margin-bottom: 2.6rem;
  background-color: ${colors.neutral[100]};

  ${breakpointsMQ4.xl.down} {
    position: static;
  }
`;

export const ElementsQuantityStyled = styled.p`
  font-size: 1.6rem;
  line-height: 2.4rem;
  letter-spacing: 0.02em;
  margin: 0;
`;

export const QuantityStyled = styled.b`
  margin-right: 0.5rem;
`;

export const SearchInputWrapperStyled = styled.div`
  svg {
    width: 1.8rem;
    height: 1.8rem;
  }
`;

export const ElectionsContentWrapperStyled = styled.div<{ $isElectionCompleted: boolean }>`
  margin: 0 auto;
  max-width: 109.6rem;
  position: relative;
  min-height: 20rem;
  margin-bottom: 4rem;
  ${({ $isElectionCompleted }): CSSProp =>
    $isElectionCompleted &&
    css`
      cursor: not-allowed;
      pointer-events: none;

      &::after {
        content: '';
        display: block;
        height: 100%;
        width: 109.6rem;
        background-color: ${colors.neutral[100]};
        z-index: 20;
        position: absolute;
        top: 0;
        left: 0;
        pointer-events: auto;
        cursor: not-allowed;
        opacity: 0.5;
      }
    `}
`;

const styles = {
  headerRow: {
    padding: '2rem 0 2rem',
  },
  electionsTableWrapper: {
    marginBottom: '3rem',
  },
  tableRow: {
    '&:first-child td': {
      paddingTop: 0,
    },
    '&:last-child td': {
      paddingBottom: 0,
    },
  },
  tableCell: {
    padding: '2.6rem 0rem',
  },
  subscribersTableBody: {
    '&::after': {
      backgroundColor: 'rgba(242,244,249, 0.5)',
      zIndex: 2,
    },
  },

  statusWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',
    '@media (width <= 1400px)': {
      flexDirection: 'row-reverse',
    },
  },
  invitationDate: {
    margin: '0',
  },
  removedSubName: {
    margin: '0 0.5rem',
    color: colors.neutral[900],
  },
};

const createStyles = createUseStyles(styles);

export { createStyles };
